import { accentFor } from './theme'

// Simplified 2D take on the desktop's radial pressure-wave field: rings of
// compression expand outward from a pulsing source, purely via CSS animation.
export function Scene01Birth2D() {
  const accent = accentFor(0)
  const rings = [0, 0.66, 1.32, 1.98]

  return (
    <svg viewBox="0 0 320 220" style={{ width: '100%', maxWidth: 340, height: 'auto', display: 'block', margin: '0 auto' }}>
      <style>{`
        @keyframes birthRing {
          0% { r: 6; opacity: 0.9; }
          100% { r: 100; opacity: 0; }
        }
        @keyframes birthPulse {
          0%, 100% { transform: scale(0.9); }
          50% { transform: scale(1.08); }
        }
      `}</style>
      {rings.map((delay, i) => (
        <circle
          key={i}
          cx="160" cy="110" r="6"
          fill="none"
          stroke={accent}
          strokeWidth="1.5"
          style={{
            animation: `birthRing 2.64s linear infinite`,
            animationDelay: `${-delay}s`,
          }}
        />
      ))}
      <circle
        cx="160" cy="110" r="10"
        fill={accent}
        style={{ transformOrigin: '160px 110px', animation: 'birthPulse 1.3s ease-in-out infinite' }}
      />
    </svg>
  )
}
